export default "__VITE_ASSET__c76d8b49__"